import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="12" fill="#FF4C00" />
      <path
        d="M15.8196 18H8.34763V16.48C9.32896 15.6907 10.177 14.992 10.8916 14.384C11.617 13.776 12.2143 13.216 12.6836 12.704C13.1636 12.192 13.5156 11.7067 13.7396 11.248C13.9743 10.7893 14.0916 10.3093 14.0916 9.808C14.0916 9.17867 13.8996 8.672 13.5156 8.288C13.1316 7.89333 12.5716 7.696 11.8356 7.696C11.2063 7.696 10.625 7.84533 10.0916 8.144C9.55829 8.432 9.07829 8.81067 8.65163 9.28V7.664C9.05696 7.25867 9.52096 6.944 10.0436 6.72C10.5663 6.48533 11.1796 6.368 11.8836 6.368C12.481 6.368 13.0143 6.448 13.4836 6.608C13.953 6.768 14.3476 6.992 14.6676 7.28C14.9876 7.568 15.2276 7.91467 15.3876 8.32C15.5583 8.72533 15.6436 9.17333 15.6436 9.664C15.6436 10.2827 15.5156 10.864 15.2596 11.408C15.0143 11.952 14.6516 12.496 14.1716 13.04C13.6916 13.5733 13.0996 14.1333 12.3956 14.72C11.7023 15.296 10.9076 15.9307 10.0116 16.624H15.8196V18Z"
        fill="white"
      />
    </svg>
  )
}
